// Add your custom JS here.


import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import { arrow } from "@popperjs/core";
// 以降、FancyBoxを使用
Fancybox.bind("[data-fancybox]", {
    // オプションを設定することができます
});

jQuery(document).ready(function($) {
    // Example: Smooth scroll for anchor links
    $('a[href*="#"]').on('click', function (e) {
        var hash = this.hash; // #toyama-station-north

        if (!hash) return;

        var $target = $(hash);
        if (!$target.length) return;

        e.preventDefault();

        $('html, body').animate({
            scrollTop: $target.offset().top
        }, 500, 'linear');
    });

    $('#overview-gallery').slick({
        autoplay: true,
        arrows: false,
        dots:true,
    });

    $('#slider img').each(function () {
        const src = $(this).attr('src');

        // すでにラップ済みならスキップ
        if (!$(this).parent().is('a')) {
            $(this).wrap(`<a data-fancybox="gallery" href="${src}"></a>`);
        }
    });

    $('#slider > *').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        autoplay: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    // Fancybox のバインド
    Fancybox.bind('[data-fancybox="gallery"]', {
        Thumbs: false,
    });




});


document.addEventListener("DOMContentLoaded", function () {

    // 投稿本文内のみを対象（必要に応じて調整）
    const content = document.querySelector(".entry-content");
    if (!content) return;

    // 画像リンクを取得
    const imageLinks = content.querySelectorAll(
        'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".webp"], a[href$=".gif"]'
    );

    imageLinks.forEach((link) => {

        // すでに fancybox 指定があれば除外
        if (link.dataset.fancybox) return;

        // ギャラリーブロック内かどうか
        const gallery = link.closest(".wp-block-gallery");

        if (gallery) {
            // ギャラリー単位でグループ化
            const galleryId =
                gallery.dataset.fancyboxId ||
                `gallery-${Math.random().toString(36).slice(2)}`;

            gallery.dataset.fancyboxId = galleryId;
            link.dataset.fancybox = galleryId;
        } else {
            // 単体画像
            link.dataset.fancybox = "image";
        }
    });

    // Fancybox 初期化
    Fancybox.bind('[data-fancybox]', {
        groupAll: false,
        hideScrollbar: true,
    });
});



document.addEventListener("DOMContentLoaded", () => {

    const elements = document.querySelectorAll(".section-tour-genre .taxonomy-thumbnail img");

    if (elements.length === 0) return;

    window.addEventListener("scroll", () => {

        elements.forEach((img) => {

            const rect = img.parentElement.getBoundingClientRect();

            const speed = 0.3;
            const baseOffset = -100; // ← 上に移動（マイナス）

            const offset = rect.top * speed + baseOffset;
            img.style.transform = `translateY(${offset}px)`;

        });

    });

});


document.addEventListener('DOMContentLoaded', () => {
    const btn = document.querySelector('.js-scroll-top');
    if (!btn) return;

    const triggerY = window.innerHeight;
    let isVisible = false;
    let isAnimating = false;

    const scrollToTop = (e) => {
        e.preventDefault();
        if (isAnimating) return;

        isAnimating = true;
        btn.classList.add('is-leave', 'is-animating');

        window.scrollTo({ top: 0, behavior: 'smooth' });

        // フォールバック: 1.2秒後に強制リセット（Safari対応）
        setTimeout(() => {
            btn.classList.remove('is-visible', 'is-leave', 'is-animating', 'is-enter');
            isVisible = false;
            isAnimating = false;
        }, 1200);
    };

    btn.addEventListener('pointerup', scrollToTop);

    const updateVisibility = () => {
        const scrollY = window.scrollY;

        if (scrollY > triggerY && !isVisible && !isAnimating) {
            isVisible = true;
            btn.classList.add('is-visible', 'is-enter');
        }

        if (scrollY <= triggerY && isVisible && !isAnimating) {
            isAnimating = true;
            btn.classList.add('is-leave', 'is-animating');

            // フォールバック: 1.2秒後に強制リセット
            setTimeout(() => {
                btn.classList.remove('is-visible', 'is-leave', 'is-animating', 'is-enter');
                isVisible = false;
                isAnimating = false;
            }, 1200);
        }
    };

    window.addEventListener('scroll', updateVisibility);

    btn.addEventListener('animationend', (e) => {
        if (e.target !== btn) return;

        if (e.animationName === 'enterAnimation') {
            btn.classList.remove('is-enter');
        }

        if (e.animationName === 'goUp') {
            btn.classList.remove('is-visible', 'is-leave', 'is-animating', 'is-enter');
            isVisible = false;
            isAnimating = false;
        }
    });
});